// extracted by mini-css-extract-plugin
export default {"clickable":"title_clickable__3oE1R","link":"title_link__37Un3"};